import { ValueObject } from './ValueObject';

// TODO: This should be a valid object
export type LocalSearchMetaheuristic =
  | `AUTOMATIC`
  | `GREEDY_DESCENT`
  | `GUIDED_LOCAL_SEARCH`
  | `SIMULATED_ANNEALING`
  | `TABU_SEARCH`;

// TODO: This should be a valid object
export type FirstSolutionStrategy =
  | `AUTOMATIC`
  | `PATH_CHEAPEST_ARC`
  | `PATH_MOST_CONSTRAINED_ARC`
  | `EVALUATOR_STRATEGY`
  | `SAVINGS`
  | `SWEEP`
  | `CHRISTOFIDES`
  | `ALL_UNPERFORMED`
  | `BEST_INSERTION`
  | `PARALLEL_CHEAPEST_INSERTION`
  | `LOCAL_CHEAPEST_INSERTION`
  | `GLOBAL_CHEAPEST_ARC`
  | `LOCAL_CHEAPEST_ARC`
  | `FIRST_UNBOUND_MIN_VALUE`;

export interface OptimizerConfigProps {
  max_wait_time?: number;
  first_solution_strategy?: FirstSolutionStrategy;
  local_search_strategy?: LocalSearchMetaheuristic;
  time_limit_seconds?: number;
  lns_time_limit?: number;
  balance_services?: boolean;
  service_duration?: number;
  time_span_coefficient?: number;
  distance_span_coefficient?: number;
  use_distance?: boolean;
  drop_penalty?: number;
  distance_balance?: number;
  isolation_factor?: number;
  stop_grouping_distance?: number;
}
const OptimizerConfigId = [
  `max_wait_time`,
  `first_solution_strategy`,
  `local_search_strategy`,
  `time_limit_seconds`,
  `lns_time_limit`,
  `balance_services`,
  `service_duration`,
  `time_span_coefficient`,
  `distance_span_coefficient`,
  `use_distance`,
  `drop_penalty`,
  `distance_balance`,
  `isolation_factor`,
];
export type OptimizerConfigIdType = (typeof OptimizerConfigId)[number];
export class OptimizerConfig extends ValueObject<OptimizerConfigProps> {
  get max_wait_time(): number | undefined {
    return this.props.max_wait_time;
  }
  set max_wait_time(maxWaitTime: number | undefined) {
    this.props.max_wait_time = maxWaitTime;
  }
  get first_solution_strategy(): FirstSolutionStrategy | undefined {
    return this.props.first_solution_strategy;
  }
  set first_solution_strategy(firstSolutionStrategy: FirstSolutionStrategy | undefined) {
    this.props.first_solution_strategy = firstSolutionStrategy;
  }
  get local_search_strategy(): LocalSearchMetaheuristic | undefined {
    return this.props.local_search_strategy;
  }
  set local_search_strategy(localSearchStrategy: LocalSearchMetaheuristic | undefined) {
    this.props.local_search_strategy = localSearchStrategy;
  }
  get time_limit_seconds(): number | undefined {
    return this.props.time_limit_seconds;
  }
  set time_limit_seconds(timeLimitSeconds: number | undefined) {
    this.props.time_limit_seconds = timeLimitSeconds;
  }
  get lns_time_limit(): number | undefined {
    return this.props.lns_time_limit;
  }
  set lns_time_limit(lnsTimeLimit: number | undefined) {
    this.props.lns_time_limit = lnsTimeLimit;
  }
  get balance_services(): boolean | undefined {
    return this.props.balance_services;
  }
  set balance_services(balanceServices: boolean | undefined) {
    this.props.balance_services = balanceServices;
  }
  get isolation_factor(): number | undefined {
    return this.props.isolation_factor;
  }
  set isolation_factor(isolationFactor: number | undefined) {
    this.props.isolation_factor = isolationFactor;
  }
  get service_duration(): number | undefined {
    return this.props.service_duration;
  }
  set service_duration(serviceDuration: number | undefined) {
    this.props.service_duration = serviceDuration;
  }
  get time_span_coefficient(): number | undefined {
    return this.props.time_span_coefficient;
  }
  set time_span_coefficient(timeSpanCoefficient: number | undefined) {
    this.props.time_span_coefficient = timeSpanCoefficient;
  }
  get distance_span_coefficient(): number | undefined {
    return this.props.distance_span_coefficient;
  }
  set distance_span_coefficient(distanceSpanCoefficient: number | undefined) {
    this.props.distance_span_coefficient = distanceSpanCoefficient;
  }
  get drop_penalty(): number | undefined {
    return this.props.drop_penalty;
  }
  set drop_penalty(dropPenalty: number | undefined) {
    this.props.drop_penalty = dropPenalty;
  }
  get distance_balance(): number | undefined {
    return this.props.distance_balance;
  }
  set distance_balance(distanceBalance: number | undefined) {
    this.props.distance_balance = distanceBalance;
  }
  get stop_grouping_distance(): number | undefined {
    return this.props.stop_grouping_distance;
  }
  set stop_grouping_distance(stopGroupingDistance: number | undefined) {
    this.props.stop_grouping_distance = stopGroupingDistance;
  }

  get use_distance(): boolean | undefined {
    return this.props.use_distance;
  }
  set use_distance(useDistance: boolean | undefined) {
    this.props.use_distance = useDistance;
  }

  getField(field: OptimizerConfigIdType): any {
    return (this.props as any)[field];
  }
  updateField({ fieldId, value }: { fieldId: OptimizerConfigIdType; value: any }): void {
    (this.props as any)[fieldId] = value;
  }
  constructor(props: OptimizerConfigProps) {
    super(props);
  }
  static create(props: OptimizerConfigProps): OptimizerConfig {
    return new OptimizerConfig(props);
  }
}
